<template>
  <div id="users" class="px-4 py-4">
    <admin-list />
  </div>
</template>
<script>
import AdminList from "@/components/admin_management/AdminList.vue";
export default {
  components: {
    AdminList
  }
};
</script>
